<template>
    <b-form class="step-form" @submit.stop.prevent="onSubmit">
        <div v-if="!showPageLoader" class="row">
            <div class="col-lg-12">
                <div class="row">
                    <template v-for="(field, index) in fields">
                        <!-- Company Fetch Fields -->
                        <template v-if="customerType == 'company' && route.includes('setup-profile') && showCompanyFeature && index == 0">
                            <company-auto-fill :fields="fields"></company-auto-fill>
                        </template>
                        <!-- Company Fetch Fields End -->
                        <div
                            v-if=""
                            :key="index"
                            :class="{
                                [field.class]: true,
                                'col-lg-12':
                                    field.type == 'heading' ||
                                    field.type == 'multi-text-field' ||
                                    field.type == 'multi-field' ||
                                    field.colSize == '12' ||
                                    field.key == 'accountInfo.enhancedDueDiligence.dateOfEdd',
                                'col-md-4':
                                    (field.type !== 'heading' &&
                                        !field.class) ||
                                    field.colSize == '4',
                                'col-md-8':
                                    ((index == 4 || index == 6) &&
                                        section == 'account-info') ||
                                    field.colSize == '8',
                                'col-md-5':
                                    ((field.key == 'identityInfo.number' ||
                                        field.key ==
                                            'identityInfo.passport.number') &&
                                        section == 'setup-profile') ||
                                    field.colSize == '5',
                            }"
                        >
                            <div
                                v-if="field.type == 'heading' && index > 0"
                                class="form-border"
                            ></div>
                            <small
                                v-if="
                                    field.type == 'sourceoffunds-evidence' ||
                                    field.type == 'sourceofwealth-evidence'
                                "
                                class="mt-2"
                                ><em
                                    class="dropzoneText"
                                    style="float: right; cursor: pointer"
                                    @click="openPopup(field.type)"
                                    >View Latest file</em
                                ></small
                            >

                            <!-- <component
                                v-if="!isTrue"
                                :is="field.type"
                                :field="{...field, customerDetails: {...customerDetails}}"
                                :data-segment-id="dataSegmentId"
                            ></component> -->
                            <component
                                :is="field.type"
                                :field="{
                                    ...field,
                                    customerDetails: { ...customerDetails },
                                }"
                                :data-segment-id="dataSegmentId"
                            ></component>
                        </div>
                        
                    <!-- Address Fetch Fields -->
                    <template v-if="customerType != 'company' && showAddressFeature && field.type == 'heading' && field.title=='Contact Information'">
                        <address-auto-fill :checkAddressExists="true" :fields="fields"></address-auto-fill>
                    </template>
                </template>

                    <div class="col-lg-12">
                        <div class="form-border"></div>
                    </div>
                </div>
                <b-button
                    v-if="
                        configData.documentUpload == true ||
                        !$route.path.includes('setup-profile')
                    "
                    size="sm"
                    class="mr-3"
                    variant="secondary"
                    @click="$router.go(-1)"
                >
                    Back
                </b-button>
                <base-button
                    btn-type="submit"
                    btn-variant="primary"
                    btn-label="CONTINUE"
                    class="mr-3"
                    :class="loading ? 'disabled' : ''"
                    :disabled="loading"
                ></base-button>

                <span v-if="loading" class="secondary-color">
                    Please wait. We're processing your request...</span
                >
            </div>
        </div>
        <!-- When data is loading -->
        <base-table-spinner v-if="showPageLoader"></base-table-spinner>
        <sourceoffunds-document
            v-if="
                customerDetails.documentInfo &&
                customerDetails.documentInfo.fundsEvidenceDocument
            "
            :item="customerDetails.documentInfo.fundsEvidenceDocument"
        ></sourceoffunds-document>
        <sourceofwealth-document
            v-if="
                customerDetails.documentInfo &&
                customerDetails.documentInfo.wealthEvidenceDocument
            "
            :item="customerDetails.documentInfo.wealthEvidenceDocument"
        ></sourceofwealth-document>

        <confirmation-popup
                :customerId="customerId"
                :message = "message"
                type = "existsCheck"
                @updateExistsCheck="updateExistsCheck"
        ></confirmation-popup>

        <KYBConfirmPopup
        :customerId="customerId"
        :message = "message"
        type = "existsCheck"
        confirmText="Create a new profile"
        cancelText="Do not proceed"
        customBtnText="Tag to existing profile"
        :customBtnFunction="tagToExistingCustomers"
        @updateExistsCheck="updateExistsCheck"
        ></KYBConfirmPopup>
    </b-form>
</template>
<script>
import { mapGetters } from 'vuex'
import { mapState } from 'vuex'

import request from '@/utils/request'

import Heading from '@/components/registration/Heading.vue'
import TextField from '@/components/registration/TextField.vue'
import TextArea from '@/components/registration/TextArea.vue'
import DatePicker from '@/components/registration/DatePicker.vue'
import List from '@/components/registration/List.vue'
import Dropdown from '@/components/registration/Dropdown.vue'
import Radio from '@/components/registration/Radio.vue'
import Checkbox from '@/components/registration/Checkbox.vue'
import PhoneNumber from '@/components/registration/PhoneNumber.vue'
import IdentityType from '@/components/registration/IdentityType.vue'
import IdentityDocumentExpiry from '@/components/registration/IdentityDocumentExpiry.vue'
import Country from '@/components/registration/Country.vue'
import Nationality from '@/components/registration/Nationality.vue'
import TaxId from '@/components/registration/TaxId.vue'
import WorkType from '@/components/registration/WorkType.vue'
import Industry from '@/components/registration/Industry.vue'
import resource from '@/api/resource'
const modulesApi = new resource('configurations/modules')
import TermsAndCondition from '@/components/registration/TermsAndCondition.vue'
// import OtpModal from '@/components/registration/OtpModal.vue'
import OtherNationalities from '@/components/registration/OtherNationalities.vue'
import SourceoffundsEvidence from '@/components/registration/SourceOfFundsDocument.vue'
import SourceofwealthEvidence from '@/components/registration/SourceOfWealthDocument.vue'
import MultiTextField from '@/components/registration/MultiTextField.vue'
import MultiSelect from '@/components/registration/MultiSelect.vue'
import MultiSelectOld from '@/components/registration/MultiSelectOld.vue'
import FileInput from '@/components/registration/FileInput.vue'
// Popups
import sourceoffundsDocument from '@/components/popups/SourceoffundsDocument.vue'
import sourceofwealthDocument from '@/components/popups/SourceofwealthDocument.vue'
import InvestmentRange from '@/components/registration/InvestmentRange.vue'
import AddressAutoFill from '@/components/AddressAutoFill.vue'
import CompanyAutoFill from '@/components/CompanyAutoFill.vue'
import MultiField from '@/components/registration/MultiField.vue'
import ConfirmationPopup from '@/components/popups/ConfirmationPopup.vue'
import KYBConfirmPopup from '@/components/popups/KYBConfirmPopup.vue'
import ListOrTextField from '../../components/registration/ListOrTextField.vue'
// import Cropper from '../../components/registration/Cropper.vue'
import EmiratesId from '../../components/registration/EmiratesId.vue'

export default {
    /*
  |--------------------------------------------------------------------------
  | Component > components
  |--------------------------------------------------------------------------
  */
    components: {
        EmiratesId,
        // Cropper,
        ListOrTextField,
        CompanyAutoFill,
        AddressAutoFill,
        Heading,
        TextField,
        TextArea,
        DatePicker,
        List,
        Dropdown,
        Radio,
        Checkbox,
        PhoneNumber,
        IdentityType,
        IdentityDocumentExpiry,
        Country,
        Nationality,
        TaxId,
        WorkType,
        Industry,
        TermsAndCondition,
        // OtpModal,
        OtherNationalities,
        SourceoffundsEvidence,
        SourceofwealthEvidence,
        //popups
        sourceoffundsDocument,
        sourceofwealthDocument,
        MultiField,
        MultiTextField,
        MultiSelect,
        MultiSelectOld,
        FileInput,
        InvestmentRange,
        ConfirmationPopup,
        KYBConfirmPopup,
    }, // End of Component > components

    /*
  |--------------------------------------------------------------------------
  | Component > props
  |--------------------------------------------------------------------------
  */
    props: {}, // End of Component > props

    /*
  |--------------------------------------------------------------------------
  | Component > data
  |--------------------------------------------------------------------------
  */
    data() {
        return {
            customerDetails: {},
            section: 'setup-profile',
            fields: [],
            showPageLoader: true,
            is_data_fetched: false,
            riskFactor: null,
            configData: [],
            existsCheck:false,
            customerId: null,
            message: null,
            showAddressFeature: process.env.VUE_APP_AUTO_ADDRESS_FILL == 'true',
            showCompanyFeature: process.env.VUE_APP_AUTO_FILL_COMPANY == 'true',
            country: process.env.VUE_APP_COUNTRY,
            tempCountry: process.env.VUE_APP_COUNTRY_TEMP,
        }
    }, // End of Component > data

    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        ...mapState({
            restrictDuplicateCustomers: (state) =>
                state.registration.restrictDuplicateCustomers,
        }),

        ...mapGetters(['dataSegmentId', 'loading', 'form', 'user', 'getField','getRegState']),

        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
        customerType(){
            return this.form.type
        },
        route(){
          return this.$route.path
        },
        cardType() {
            return this.$store.getters.getField('identityInfo.cardType')
        },
    }, // End of Component > mounted

    /*
  |--------------------------------------------------------------------------
  | Component > watch
  |--------------------------------------------------------------------------
  */
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.getRecords()
            }
        },
    }, // End of Component > methods

    /*
  |--------------------------------------------------------------------------
  | Component > mounted
  |--------------------------------------------------------------------------
  */
    async created() {
        this.configData = this.$store.state.registration.configData
    },
    async mounted() {
        const path = this.$route.path.split('/')
        await this.getCustomerDetails()
        await this.getRecords()

        if (path[path.length - 2] == 'setup-profile') {
            if (this.configData.nameScreening == false) {
                if (this.configData.riskFactor == false) {
                    if (this.configData.additionalInfo == false || this.configData.accountinfo == false) {
                        this.$router.push({ name: 'edit-profile-preview' })
                    } else {
                        this.$router.push({
                            name: 'edit-profile-additional-info',
                        })
                    }
                } else {
                    if(this.configData.accountinfo == false )
                    {
                    this.$router.push({ name: 'edit-profile-preview' })
                    }
                else{
                    this.$router.push({ name: 'edit-profile-account-info' })
                }
                  
                }
            }
        }
    }, // End of Component > computed

    /*
  |--------------------------------------------------------------------------
  | Component > methods
  |--------------------------------------------------------------------------
  */
    methods: {
        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */
        async isUpdateField(){
                let countries = ['UAE','Qatar']
                let cardTypes = [ 'QAT RP 0 FRONT', 'QAT RP 1 FRONT','QAT RP 0 BACK' , 'QAT RP 1 BACK',
                                'ARE ID 0 FRONT', 'ARE ID 0 BACK', 
                                'ARE ID 1 FRONT', 'ARE ID 1 BACK'
                                ]
                let cardTypeOverride  = this.getRegState('cardTypeOverride')
                if( (countries.includes(this.tempCountry) && cardTypes.includes(cardTypeOverride) ) || !this.cardType ){
                     return true
                }else if ( !countries.includes(this.tempCountry) ){
                    return true
                }
                return false
             },
        isOcrCountry() {
            if ( this.country == 'United Arab Emirates' ||
                this.country == 'Pakistan' ||
                this.tempCountry == 'UK' ||
                this.tempCountry == 'Qatar'
            ) {
                return true
            }
            return false
        },
        async ocrFieldHandling(cardType, customerDetails) {

                // let TypesForIdentityInfo = ['license','brp','URDU','SMART','qrp','uaeOldResidentCard', 'uaeSmartResidentCard']
                // let TypesForPassport = ['passport','passportMRZ']
                // let TypesForNationality = ['SMART','passport','passportMRZ', 'brp','qrp','uaeOldResidentCard', 'uaeSmartResidentCard']
                // let TypesForGender = ['SMART','passport','passportMRZ', 'brp']
                // let TypesForGeneric = ['license','SMART','URDU','passport','passportMRZ']
            // let cardType = cardType
            // if(TypesForGeneric.includes(cardType)){
                    if (
                        this.getField('basicInfo.firstName') &&
                        customerDetails.basicInfo.firstName
                    ) {
                        delete customerDetails.basicInfo.firstName
                    }
                    if (
                        this.getField('basicInfo.dateOfBirth') &&
                        customerDetails.basicInfo.dateOfBirth
                    ) {
                        delete customerDetails.basicInfo.dateOfBirth
                    }
                    if (
                        this.getField(
                            'documentInfo.ocrPicture.fileName' &&
                                customerDetails.documentInfo.ocrPicture &&
                                customerDetails.documentInfo.ocrPicture.fileName
                        )
                    ) {
                        delete customerDetails.documentInfo.ocrPicture.fileName
                    }
            // }  
            // if (TypesForGender.includes(cardType)) {
                if (
                    this.getField(
                        'basicInfo.gender' && customerDetails.basicInfo.gender
                    )
                ) {
                    delete customerDetails.basicInfo.gender
                }
                if (
                    this.getField('basicInfo.genderId') &&
                    customerDetails.basicInfo.genderId
                ) {
                    delete customerDetails.basicInfo.genderId
                }
            // }
            // if (TypesForNationality.includes(cardType)) {
                if (
                       this.getField('basicInfo.nationalityId') && await this.isUpdateField()
                    && customerDetails.basicInfo.nationalityId
                ) {
                    delete customerDetails.basicInfo.nationalityId
                }
                if (
                       this.getField('basicInfo.nationality')  && await this.isUpdateField()
                    && customerDetails.basicInfo.nationality
                ) {
                    delete customerDetails.basicInfo.nationality
                }
            // }
            // if (TypesForIdentityInfo.includes(cardType)) {
                if (
                       this.getField('identityInfo.number')  && await this.isUpdateField()
                    && customerDetails.identityInfo.number
                ) {
                    delete customerDetails.identityInfo.number
                }
                if (
                       this.getField('identityInfo.expiryDate')  && await this.isUpdateField()
                    && customerDetails.identityInfo.expiryDate
                ) {
                    delete customerDetails.identityInfo.expiryDate
                }
            // }

            // if (TypesForPassport.includes(cardType)) {
                if (
                    ( this.getField('identityInfo.passport.number') ||
                      this.getField('identityInfo.passport.expiryDate') 
                    ) &&
                    customerDetails.identityInfo.hasOwnProperty('passport')
                   )
                {
                    delete customerDetails.identityInfo.passport
                }
                
            // }

            // if (this.country == 'Pakistan' && cardType == 'SMART') {
                if (
                    this.getField('basicInfo.fatherName') &&
                    customerDetails.basicInfo.fatherName
                ) {
                    delete customerDetails.basicInfo.fatherName
                }
            // }
        },
        checkField(field) {
            if (field.status && field.status == 'active') {
                if (
                    field.visibleTo &&
                    field.visibleTo.indexOf(this.$store.getters.form.type) > -1
                ) {
                    return true
                }
            }
            return false
        },
        async onSubmit() {
            // validate the form fields
            const result = await this.$validator.validateAll()

            // Check if validation fails
            if (result) {
                this.$store.commit('setLoading', true)
                if (!this.existsCheck && this.configData.restrictDuplicateCustomers && (this.$store.state.registration.form.identityInfo.number || this.$store.state.registration.form.identityInfo.passport.number)) {
                    //check customer nic if already exists with their datasegment
                    let error = false
                    try {
                        const params = {}
                        params.dataSegmentId = this.dataSegmentId
                        params.customerId =
                            this.$store.state.registration.form._id
                        params.nationalId =
                            this.$store.state.registration.form.identityInfo.number
                        params.passport =
                            this.$store.state.registration.form.identityInfo.passport.number

                        const { data } = await request({
                            url: '/customers/exists',
                            method: 'get',
                            params,
                        })
                    } catch (e) {
                        error = e
                    }
                    if (error) {
                        // this.$store.commit('setError', error)
                        this.openPopup('confirmation-popup','',error,'existsCheck')
                        // this.existsCheck=true
                        this.$store.commit('setLoading', false)
                        return false
                    }
                }
                this.nextModule('on-submit')
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method

        /**
         * get the form fields when required
         *
         * @return {void}
         */
        async getRecords() {
            try {
                let { data } = await request({
                    url: `/form-builder/`,
                    params: {
                        dataSegmentId: this.dataSegmentId,
                        section: this.section,
                        type:this.customerDetails.type,
                        isEdit:true,
                        uaepassfield:this.configData.uaepassfield
                    },
                })
                this.showPageLoader = false
                this.fields = data.data
            } catch (error) {
                console.log(error)
            }
            this.$store.commit('setLoading', false)
        }, // End of getRecords() method
        async getCustomerDetails() {
            if (
                !this.$store.state.registration.form.hasOwnProperty(
                    'setupProfileData'
                ) &&
                this.$route.path.includes('setup-profile')
            )
            {
                let {data} = await request({
                    url: `customers/for-edit-profile/${this.$route.params.id}`,
                })
                this.$store.commit('updateField', {key: 'type', value: data.data.type})
                if (!this.$store.state.registration.form.parents || this.$store.state.registration.form.parents.length==0)
                {
                    this.$store.commit('updateField', {
                        key: 'parents',
                        value: data.data.parents,
                    })
                }

                if (
                    this.isOcrCountry() &&
                    data &&
                    data.data &&
                    this.getField('type') != 'company'
                ) {
                    await this.ocrFieldHandling(this.cardType, data.data)
                }
                this.customerDetails = data.data
                this.$store.commit('updateField', {
                    key: 'setupProfileData',
                    value: true,
                })

                if (!this.$store.state.registration.form.idenfoId) {
                    this.$store.commit('updateField', {
                        key: 'idenfoId',
                        value: data.data.idenfoId,
                    })
                }

                if (!this.$store.state.registration.form._id)
                    this.$store.commit('updateField', {
                        key: '_id',
                        value: data.data._id,
                    })
                if (this.customerType == 'company' && data.data.dynamicInputValues && Object.keys(data.data.dynamicInputValues).length > 0) {
                    this.$store.commit('updateField', {
                        key: 'dynamicInputValues',
                        value: data.data.dynamicInputValues,
                    })
                }
                if (this.customerType == 'company' && data.data.companyHouseApiRiskoverrides && Object.keys(data.data.companyHouseApiRiskoverrides).length > 0) {
                    this.$store.commit('updateField', {
                        key: 'companyHouseApiRiskoverrides',
                        value: data.data.companyHouseApiRiskoverrides,
                    })
                }
                let keyForIdenityFileName = ''
                let keyForIdenityBackFileName = ''
                if (['UAE', 'Qatar'].includes(this.tempCountry) && !this.cardType) {
                    keyForIdenityFileName = 'documentInfo.fieldEmiratesID.fileName'
                    keyForIdenityBackFileName = 'documentInfo.fieldEmiratesIDBack.fileName'
                } else {
                    keyForIdenityFileName = 'documentInfo.identity.fileName'
                    keyForIdenityBackFileName = 'documentInfo.fieldEmiratesIDBack.fileName'
                }
                if (this.customerType != 'company' && this.cardType != 'passport' && this.getField(keyForIdenityFileName) && this.getField('identityInfo') && this.getField('identityInfo.documentSummary') && Object.keys(this.getField('identityInfo.documentSummary')).length < 1 &&
                    data.data.identityInfo.documentSummary && Object.keys(data.data.identityInfo.documentSummary).length > 0) {
                    this.$store.commit('updateField', {
                        key: 'identityInfo.documentSummary',
                        value: data.data.identityInfo.documentSummary,
                    })
                }
                if (this.customerType != 'company' && this.cardType != 'passport' && this.getField(keyForIdenityBackFileName) && this.getField('identityInfo') &&
                    this.getField('identityInfo.documentSummaryBack') && Object.keys(this.getField('identityInfo.documentSummaryBack')).length < 1 &&
                    data.data.identityInfo.documentSummaryBack && Object.keys(data.data.identityInfo.documentSummaryBack).length > 0) {
                    this.$store.commit('updateField', {
                        key: 'identityInfo.documentSummaryBack',
                        value: data.data.identityInfo.documentSummaryBack,
                    })
                }
                let updatePassportDocumentSummary = (this.cardType == 'passport' && this.tempCountry == 'UK') || (['UAE', 'Qatar'].includes(this.tempCountry))
                if (this.customerType != 'company' && updatePassportDocumentSummary && this.getField('documentInfo.identity.fileName') && this.getField('identityInfo.passport.documentSummary') &&
                    Object.keys(this.getField('identityInfo.passport.documentSummary')).length < 1 &&
                    data.data.identityInfo.passport.documentSummary && Object.keys(data.data.identityInfo.passport.documentSummary).length > 0) {
                    this.$store.commit('updateField', {
                        key: 'identityInfo.passport.documentSummary',
                        value: data.data.identityInfo.passport.documentSummary,
                    })
                }
            }
            else if (!this.$store.state.registration.form.hasOwnProperty("accountInfoData") && this.$route.path.includes('account-info'))
            {
                let {data} = await request({
                    url: `customers/for-edit-profile/${this.$route.params.id}`,
                })
                this.$store.commit('updateField', {key: 'type', value: data.data.type})
                this.customerDetails = data.data

                // this.$store.state.registration.form = data.data
                this.$store.commit('updateField', {
                    key: 'accountInfoData',
                    value: true,
                })

                if (!this.$store.state.registration.form.idenfoId) {
                    this.$store.commit('updateField', {
                        key: 'idenfoId',
                        value: data.data.idenfoId,
                    })
                }

                if (!this.$store.state.registration.form._id)
                    this.$store.commit('updateField', {
                        key: '_id',
                        value: data.data._id,
                    })
                if (!this.$store.state.registration.form.parents)
                {
                    this.$store.commit('updateField', {
                        key: 'parents',
                        value: data.data.parents,
                    })
                }
            }
            else if (
                !this.$store.state.registration.form.hasOwnProperty(
                    'additionalInfoData'
                ) &&
                this.$route.path.includes('additional-info')
            )
            {
                let {data} = await request({
                    url: `customers/for-edit-profile/${this.$route.params.id}`,
                })
                this.$store.commit('updateField', {key: 'type', value: data.data.type})
                this.customerDetails = data.data
                // this.$store.state.registration.form = data.data
                this.$store.commit('updateField', {
                    key: 'additionalInfoData',
                    value: true,
                })
                if (!this.$store.state.registration.form.parents)
                {
                    this.$store.commit('updateField', {
                        key: 'parents',
                        value: data.data.parents,
                    })
                }
            } else {
                this.customerDetails = this.$store.state.registration.form
            }
        },
        openPopup(popup,customerId,message,type) {
            switch (popup) {
                case 'sourceofwealth-evidence':
                    if (
                        this.customerDetails.documentInfo
                            .wealthEvidenceDocument &&
                        this.customerDetails.documentInfo.wealthEvidenceDocument
                            .fileName
                    ) {
                        this.$bvModal.show('sourceofwealth-document')
                    } else {
                        this.$store.commit('setError', 'No file uploaded')
                    }
                    break
                case 'sourceoffunds-evidence':
                    if (
                        this.customerDetails.documentInfo
                            .fundsEvidenceDocument &&
                        this.customerDetails.documentInfo.fundsEvidenceDocument
                            .fileName
                    ) {
                        this.$bvModal.show('sourceoffunds-document')
                    } else {
                        this.$store.commit('setError', 'No file uploaded')
                    }
                    break
                case 'confirmation-popup':
                case 'kyc-confirmation-popup':
                    this.customerId=customerId
                    this.message=message
                    this.type=type
                    this.$bvModal.show(popup)
                    break;

            }
        },
        async updateExistsCheck(value)
        {
            if(!value)
            {
                this.$store.commit('initDefaultFields', 'form')
                this.$router.push('/customer-profiles/edit-profile/'+ this.customerDetails._id);
                // if(this.configData.documentUpload==true)
                // {
                //     this.$router.push('/self-register/upload-document')
                // }else {
                //     this.$store.commit('initDefaultFields', 'form')
                // }
            }
            else
            {
                this.existsCheck=value
            }
        },
        async tagToExistingCustomers()
        {
        },
        async nextModule(type = '') {
            if(this.configData.accountinfo == false)
            {
                this.$router.push({ name: 'edit-profile-preview' })
            }
            else{
                this.$router.push({ name: 'edit-profile-account-info' })
            }
         
            // if (this.configData.riskFactor == false) {
            //     if(this.configData.additionalInfo == false || this.customerDetails.type=='company'){
            //         if (this.$route.meta.publicRegistration === true) {
            //         this.$router.push({
            //             name: 'edit-profile-preview',
            //             params: {
            //                 dataSegmentId: this.dataSegmentId,
            //                 id:this.$route.params.id
            //             },
            //         })
            //     } else {
            //         this.$router.push(`/customer-profiles/edit-profile/preview/${this.$route.params.id}/`)
            //     }
            //     }else{
            //         this.$router.push({name:'edit-profile-additional-info'})
            //     }
            //
            // } else {
            //     this.$router.push({name:'edit-profile-account-info'})
            // }
        },
    }, // End of Component > watch
} // End of export default
</script>
